module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Regular.eot
// module id = 267
// module chunks = 0